var $c7b6794213c982a7$exports = {};
$c7b6794213c982a7$exports = {
    "loading": `\u{141}adowanie...`,
    "loadingMore": `Wczytywanie wi\u{119}kszej liczby...`
};


export {$c7b6794213c982a7$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
